import Vue from 'vue';
import { VueReCaptcha } from 'vue-recaptcha-v3';

const key = window?.afConfig?.google_recaptcha_key ? window.afConfig.google_recaptcha_key : process.env.VUE_APP_GOOGLE_CAPTCHA;
Vue.use(VueReCaptcha, { siteKey: key });
